<template>
  <div class="page-content">
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="breadcrumbs" />
        <h1 class="page-title" v-if="customer.full_name">{{ customer.full_name }}</h1>
        <p class="page-subtitle" v-if="customer.phone">{{ customer.phone }}</p>
      </div>
    </div>

    <PreloaderComponent :enable="enable" />

    <div v-if="enable">
      <!-- Summary cards -->
      <v-row class="mb-2">
        <v-col cols="6" md="3">
          <v-card flat class="summary-card">
            <div class="summary-icon-sm" style="background:#F44336"><v-icon color="white" size="18">mdi-cash-clock</v-icon></div>
            <div class="summary-val" :class="customer.total_balance_htg > 0 ? 'error--text' : 'success--text'">{{ fmt(customer.total_balance_htg) }}</div>
            <div class="summary-lbl">Solde HTG</div>
          </v-card>
        </v-col>
        <v-col cols="6" md="3">
          <v-card flat class="summary-card">
            <div class="summary-icon-sm" style="background:#2196F3"><v-icon color="white" size="18">mdi-credit-card-outline</v-icon></div>
            <div class="summary-val">{{ fmt(customer.available_credit) }}</div>
            <div class="summary-lbl">Crédit Disponible</div>
          </v-card>
        </v-col>
        <v-col cols="6" md="3">
          <v-card flat class="summary-card">
            <div class="summary-icon-sm" style="background:#194173"><v-icon color="white" size="18">mdi-shield-check</v-icon></div>
            <div class="summary-val">{{ fmt(customer.credit_limit) }}</div>
            <div class="summary-lbl">Limite de Crédit</div>
          </v-card>
        </v-col>
        <v-col cols="6" md="3">
          <v-card flat class="summary-card">
            <div class="summary-icon-sm" style="background:#f68d3b"><v-icon color="white" size="18">mdi-percent</v-icon></div>
            <div class="summary-val">{{ customer.discount || 0 }}%</div>
            <div class="summary-lbl">Réduction</div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Statements table -->
      <v-card flat class="table-card">
        <div class="d-flex align-center justify-space-between pa-3">
          <span class="text-subtitle-2 font-weight-bold">Relevés Mensuels</span>
        </div>
        <v-simple-table dense>
          <thead>
            <tr>
              <th class="text-left">PÉRIODE</th>
              <th class="text-right">VENTES (HTG)</th>
              <th class="text-right">PAIEMENTS (HTG)</th>
              <th class="text-right">SOLDE (HTG)</th>
              <th class="text-center">STATUT</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="s in statements" :key="s.id" @click="goToStatement(s.id)" class="clickable-row">
              <td class="text-left font-weight-medium">{{ s.period_label }}</td>
              <td class="text-right">{{ fmt(s.total_sales_htg) }}</td>
              <td class="text-right success--text">{{ fmt(s.total_payments_htg) }}</td>
              <td class="text-right font-weight-bold" :class="s.balance_htg > 0 ? 'error--text' : 'success--text'">{{ fmt(s.balance_htg) }}</td>
              <td class="text-center">
                <v-chip x-small :color="getStatusColor(s.status)" dark>{{ getStatusLabel(s.status) }}</v-chip>
              </td>
              <td style="width: 80px; white-space: nowrap;">
                <v-btn icon x-small class="mr-1" @click.stop="goToStatement(s.id)">
                  <v-icon small color="primary">mdi-eye-outline</v-icon>
                </v-btn>
                <v-btn icon x-small @click.stop="downloadPdf(s.id)" :loading="pdfLoading === s.id">
                  <v-icon small color="error">mdi-file-pdf-box</v-icon>
                </v-btn>
              </td>
            </tr>
            <tr v-if="statements.length === 0">
              <td colspan="6" class="text-center text--secondary pa-6">Aucun relevé trouvé</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'
import PreloaderComponent from '../components/PreloaderComponent.vue'

export default {
  name: 'CustomerStatementsView',
  components: { BreadcrumbComponent, PreloaderComponent },
  data: () => ({
    enable: false,
    customerId: null,
    pdfLoading: null,
    customer: { full_name: '', phone: '', credit_limit: 0, discount: 0, total_balance_htg: 0, available_credit: 0 },
    statements: [],
    breadcrumbs: [
      { text: 'Clients', disabled: false, href: '/customers' },
      { text: 'Relevés', disabled: true, href: '#' },
    ],
  }),
  methods: {
    fmt(v) {
      if (!v && v !== 0) return '0.00'
      var p = Math.abs(parseFloat(v)).toFixed(2).split('.')
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      return (parseFloat(v) < 0 ? '-' : '') + p.join('.')
    },
    getStatusColor(status) {
      var map = { paid: 'success', due: 'error', partially_paid: 'warning', pending: 'info' }
      return map[status] || 'info'
    },
    getStatusLabel(status) {
      var map = { paid: 'Payé', due: 'Dû', partially_paid: 'Partiel', pending: 'En cours' }
      return map[status] || status
    },
    goToStatement(statementId) {
      this.$router.push({ name: 'statement-detail', params: { id: this.customerId, statementId: statementId } })
    },
    load() {
      var self = this
      this.$axios.get('/customers/' + this.customerId + '/statements')
        .then(function (r) {
          self.customer = r.data.customer
          self.statements = r.data.statements
          self.breadcrumbs = [
            { text: 'Clients', disabled: false, href: '/customers' },
            { text: self.customer.full_name, disabled: true, href: '#' },
          ]
          self.enable = true
        })
        .catch(function () { self.enable = true })
    },
    downloadPdf(statementId) {
      var self = this
      this.pdfLoading = statementId
      this.$axios.get('/customers/' + this.customerId + '/statements/' + statementId + '/pdf', { responseType: 'blob' })
        .then(function (r) {
          var blob = new Blob([r.data], { type: 'application/pdf' })
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'releve_' + self.customer.full_name.replace(/\s+/g, '_') + '_' + statementId + '.pdf'
          link.click()
          window.URL.revokeObjectURL(link.href)
          self.pdfLoading = null
        })
        .catch(function () { self.pdfLoading = null })
    },
  },
  mounted() { this.customerId = this.$route.params.id; this.load() },
}
</script>

<style scoped>
.summary-card { border: 1px solid #e8ecf1 !important; border-radius: 10px !important; box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important; padding: 16px; text-align: center; }
.summary-icon-sm { width: 36px; height: 36px; border-radius: 8px; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 8px; }
.summary-val { font-size: 1.125rem; font-weight: 700; color: #1a2332; }
.summary-lbl { font-size: 0.75rem; color: #64748b; margin-top: 2px; }
.table-card { border: 1px solid #e8ecf1 !important; border-radius: 8px !important; box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important; overflow: hidden; }
.table-card .v-simple-table thead th { font-size: 0.6875rem !important; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: #94a3b8 !important; background: transparent !important; border-bottom: 1px solid #e8ecf1 !important; padding: 8px 16px !important; }
.table-card .v-simple-table tbody td { font-size: 0.8125rem; padding: 10px 16px !important; border-bottom: 1px solid #f1f5f9 !important; }
.table-card .v-simple-table tbody tr:last-child td { border-bottom: none !important; }
.clickable-row { cursor: pointer; }
.clickable-row:hover { background: rgba(25, 65, 115, 0.03) !important; }
</style>
